import FxInactivityTimePopup from 'components/fx/components/FxInactivityTimePopup';
import { useEffect, useState } from 'react';

const INACTIVITY_TIME_DEFAULT = 1800;

const useFxCheckInactivityTime = () => {
  const [isOpenInactivityPopup, setOpenInactivityPopup] = useState(false);

  let timer;

  const handleOnClickInactivityTimePopup = () => {
    timer = null;
    setOpenInactivityPopup(false);
  };
  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
  const timeOut = INACTIVITY_TIME_DEFAULT;
  const showInactivityTimePopup = () => {
    setOpenInactivityPopup(true);
  };
  const resetTimer = () => {
    clearTimeout(timer);
    timer = setTimeout(showInactivityTimePopup, timeOut * 1000);
  };
  const checkInactivityTime = () => {
    window.addEventListener('load', resetTimer, true);
    events.forEach((name) => {
      document.addEventListener(name, resetTimer, true);
    });
  };
  useEffect(() => {
    checkInactivityTime();
    return () => {
      window.removeEventListener('load', resetTimer, true);
      events.forEach((name) => {
        document.removeEventListener(name, resetTimer, true);
      });
    };
  }, [timer]);

  return {
    isOpenInactivityPopup,
    FxInactivityTimePopup,
    handleOnClickInactivityTimePopup,
  };
};

export default useFxCheckInactivityTime;
